module.exports = __webpack_public_path__ + "img/vision.cd956270.png";